export default {
  uploadArea: {
    border: '2px dashed #ddd',
    borderRadius: 2,
    p: 6,
    textAlign: 'center',
    minHeight: 200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      borderColor: 'primary.main',
      backgroundColor: 'action.hover',
    },
  },
  uploadIcon: {
    fontSize: 64,
    color: 'text.secondary',
    mb: 2,
  },
  title: {
    fontWeight: 600,
    mb: 1,
  },
  subtitle: {
    mb: 1,
  },
  note: {
    fontSize: '0.75rem',
  },
  buttonContainer: {
    mt: 3,
    justifyContent: 'flex-end',
  },
};
